import { useSelector } from 'react-redux';

import { RootState } from 'reducers/rootReducer';

export default function useCultureCode() {
	return useSelector((state: RootState) => state.cultureCode);
}
